import createAxios from 'App/utils/createAxios';
import { getSlsBasePath } from '../utils';
import config from '../components/config/config';

const ups = createAxios({
    baseURL: `${getSlsBasePath(config, 'user')}/1.0.0/preferences`,
});

async function getUserPreferences() {
    return ups.get('');
}

async function deleteUserPreference(preferenceId) {
    return ups.delete(`/${preferenceId}`);
}

async function upsertUserPreference({ name, value }) {
    return ups.put('', { name, value });
}

export { getUserPreferences, deleteUserPreference, upsertUserPreference };
